import { ApplicationStatusName } from 'enums/ApplicationStatusName';

export const NO_OFFER_STATUSES = [
  ApplicationStatusName.Rejected,
  ApplicationStatusName.ManualReview,
  ApplicationStatusName.AlreadyApplied,
  ApplicationStatusName.OutOfState,
];
